import queryStringParser from 'query-string';
import encodeQueryValue from './encode-query-value'
import config from '../../../config'
 
export const encodeQueryString = ({query = {}, defaultQuery = {}}) => {
	const filteredQuery = Object.keys(query).reduce((newQuery, key) => {
		return !defaultQuery[key] || encodeQueryValue(defaultQuery[key]) !== encodeQueryValue(query[key]) ? {
			...newQuery,
			[key]: query[key],
		} : newQuery;
	}, {});
	
	return queryStringParser.stringify(filteredQuery, { arrayFormat: 'separator', arrayFormatSeparator: config.queryStringArraySeperator, skipNull: true, skipEmptyString: true });
}